import React from "react";
import logo from "../../assets/images/ladybrand-icon.svg";

const ladybrandLogo = props => <img src={logo} alt="Ladybrand" />;

export default ladybrandLogo;
